import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

const VideoSection = () => {
  const [videoData, setVideoData] = useState([]);
  const [videoSrc, setVideoSrc] = useState("");
  const [page, setPage] = useState(null);
  const { pageSlug } = useParams(); // Extract the pageSlug from the URL

  useEffect(() => {
    // Fetch page data based on pageSlug from URL
    fetch(`https://marchtwo202501-5801b8caeb3a.herokuapp.com/page/${pageSlug}`)
      .then((res) => res.json())
      .then((info) => {
        if (info.pageSlug === pageSlug) {
          setPage(info); // Set page data if slug matches
        }
      })
      .catch((error) => console.error("Error fetching page data:", error));
  }, [pageSlug]);

  useEffect(() => {
    // Fetch video data from server
    fetch(`https://marchtwo202501-5801b8caeb3a.herokuapp.com/videos`)
      .then((res) => res.json())
      .then((data) => {
        setVideoData(data); // Store all videos
      })
      .catch((error) => console.error("Error fetching video data:", error));
  }, []);

  // Find the video that matches the current pageSlug
  const matchingVideo = videoData.find((b) => b.pageSlug === pageSlug);

  const openModal = () => {
    if (matchingVideo?.videoLink) {
      const videoID = matchingVideo.videoLink.split("v=")[1] || "";
      setVideoSrc(`https://www.youtube.com/embed/${videoID}?autoplay=1`);
    }
  };

  // If page data or video data is still loading
  if (!page || videoData.length === 0) {
    return (
      <div className="video">
        <div className="video__wrapper">
          <div className="container">
            <p>Loading content...</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="video" id="video">
      <div className="video__wrapper">
        <div className="container">
          {/* Check if a matching video exists */}
          {matchingVideo ? (
            <>
              <div className="video__play">
                <button
                  type="button"
                  data-toggle="modal"
                  data-target="#videoModal"
                  onClick={openModal}
                >
                  <i className="fad fa-play" />
                </button>
              </div>

              {/* Video Modal */}
              <div className="modal fade" id="videoModal" tabIndex="-1" role="dialog" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered" role="document">
                  <div className="modal-content">
                    <div className="modal-close">
                      <button
                        type="button"
                        data-dismiss="modal"
                        aria-label="Close"
                        onClick={() => setVideoSrc("")}
                      >
                        <i className="fas fa-times" />
                      </button>
                    </div>
                    <div className="modal-body">
                      {videoSrc ? (
                        <iframe
                          width="100%"
                          height="400px"
                          src={videoSrc}
                          frameBorder="0"
                          allow="autoplay; encrypted-media"
                          allowFullScreen
                        />
                      ) : (
                        <p>Loading video...</p>
                      )}
                    </div>
                  </div>
                </div>
              </div>

              {/* Background Images */}
              <div className="video__background">
                <img src="assets/images/video-bg-1.png" className="texture-1" alt="Video Background" />
                <img src={matchingVideo.videoImage} alt="image" className="phone" />
                <img src="assets/images/video-bg-2.png" alt="image" className="texture-2" />
              </div>
            </>
          ) : (
            <p>No video available for this page.</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default VideoSection;
